export default "__VITE_ASSET__CsB$gSlg__"